import IpIcon from  '../../docs/light/network.png';
import LockIcon from '../../docs/light/lock.png';
import { useContext } from 'react';
import { update } from '../indexDB/indexDBStora';
import { collection } from '../../context/collect';
import { config } from '../../context/config';
import { switchh } from '../../context/switch';
import { action } from '../../context/action';
import Langs from '../../data/langs.json';
import { useTranslation } from 'react-i18next';
export default function Configuration () {
    const { t } = useTranslation();
    const { lock, setLock, language, setLanguage } = useContext(config)
    const {setCconfig, cconfig} = useContext(collection);
    const {setLoadingProcess} = useContext(switchh);
    const { setErrorMessage, setSuccessMessage } = useContext(action);
    const HandleConfig = async () => {
        if(!cconfig.ip) {
            setErrorMessage("ادخل عنوان ip بشكل صحيح")
            return;
        }
        if(!cconfig.workWay || !cconfig.mode) {
            setErrorMessage("يرجى ادخال البيانات بشكل صحيح")
            return;
        }
        setErrorMessage("")
        setLoadingProcess(true);
        await update("settings", cconfig);
        setSuccessMessage("تم حفظ الأعدادات")
        setLock(true);
        setLoadingProcess(false);
    }

    return (
        <div className="section config">
            <h4>{t("label:settings.basicConfig.title")}</h4>
                <div className="parent flex">
                    <div className="child">
                        <label>{t("label:settings.basicConfig.body.connection")}</label>
                        <div className="ipConfig">
                            <input 
                                disabled={lock}
                                inputMode="numeric"
                                onChange={(e) => {
                                    let value = e.target.value.replace(/\D/g, '');
                                    if (value.length > 12) return;

                                    let formatted = value.match(/.{1,3}/g)?.join('.') || '';
                                    setCconfig(prev => ({ ...prev, ip: formatted }));
                                }}
                                value={cconfig.ip}
                                className={lock ? "disabled-bg disabled" : "line"} 
                                type="text"
                                placeholder="IP 000.000.000.000"
                            />
                            {lock ? 
                            <button onClick={() => setLock(false)}><img alt='' src={IpIcon} /></button>
                            :
                            <button onClick={() => setLock(true)}><img alt='' src={LockIcon} /></button>
                            }
                        </div>
                    </div>
                    <div className='child'>
                        <label>{t("label:settings.basicConfig.body.devName")}</label>
                        <input maxLength={5} 
                        value={cconfig.pos}
                        onChange={(e) => 
                        setCconfig((prev) => ({...prev, pos: e.target.value.toUpperCase()}))}
                        className="line" type="text" placeholder="PoS (DVn)" />
                    </div>
                </div>
                <h5>{t("label:settings.weightConfig.title")}</h5>
                <div className="parent flex">
                    <div className="child">
                        <input
                        value={cconfig.weight.prefix || ""}
                        onChange={(e) =>
                        setCconfig(prev => ({
                            ...prev,
                            weight: {
                                ...prev.weight,
                                prefix: e.target.value
                            }
                        }))
                        }
                        className="line" type="number" placeholder={t("label:settings.weightConfig.body.prefix")} />
                    </div>
                    <div className='child'>
                        <input
                        value={cconfig.weight.cd}
                        onChange={(e) => 
                        setCconfig((prev) => ({...prev, 
                            weight: {
                                ...prev.weight, cd: e.target.value
                            }
                        }))}
                        className="line" type="number" placeholder={t("label:settings.weightConfig.body.cd")} />
                    </div>
                    <div className='parent flex'>
                        <div className='child'>
                            <label>{t("label:settings.weightConfig.title")}</label>

                            <select
                            value={String(cconfig.weightManualMode ?? "")}
                            onChange={(e) =>
                                setCconfig((prev) => ({
                                    ...prev,
                                    weightManualMode: e.target.value === "true"
                                }))
                            }
                            >
                                <option disabled value="">
                                    {t("label:settings.weightConfig.body.mode.title")}
                                </option>

                                <option value="true">
                                    {t("label:settings.weightConfig.body.mode.opt.manuall")}
                                </option>

                                <option value="false">
                                    {t("label:settings.weightConfig.body.mode.opt.auto")}
                                </option>
                            </select>
                        </div>
                        <div className='child'>
                            <label>{t("label:settings.interface.lang")}</label>

                            <select
                                value={language || ''}
                                onChange={(e) => setLanguage(e.target.value)}
                            >
                                {Langs.map((lang) => (
                                    <option
                                        key={lang.id}
                                        value={lang.Code}
                                    >
                                        {lang.title}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="parent flex">
                    <div className="child">
                        <label>{t("label:settings.interface.workFlow")}</label>
                        <select value={cconfig.workWay} onChange={(e) => setCconfig((prev)=>({...prev, workWay: e.target.value}))}>
                            <option defaultValue={''} selected disabled>{t("label:settings.interface.workFlow")}</option>
                            <option value={'barcode'}>{t("label:product.barcode")}</option>
                            <option value={'category'}>{t("label:product.category.label")}</option>
                            <option value={'both'}>{t("label:both")}</option>
                        </select>
                    </div>
                    <div className='child'>
                        <label>{t("label:settings.interface.theme")}</label>
                        <select
                            value={cconfig.mode || ""}
                            onChange={(e) =>
                                setCconfig((prev) => ({
                                    ...prev,
                                    mode: e.target.value
                                }))
                            }
                        >
                            <option value="" disabled>
                                {t("label:settings.interface.theme")}
                            </option>

                            <option value="dark">dark</option>
                            <option value="light">light</option>
                        </select>
                    </div>
                </div>
                <div className="btn">
                    <button onClick={() => HandleConfig()} className="error-bg">{t("action:save")}</button>
                </div>
            </div>
    )
}